/// <reference types="react-scripts" />
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { AppUtils } from "../../../framework/appUtils";
import { IChartItem } from "../../../models/chart/chartItem";
import { ISavedChartPanel } from "../../../models/chart/savedChartPanel";
import { IReportParameterValue } from "../../../models/report/reportParameterValue";
import * as eventService from "../../../models/services/eventService";
import { IDashboardChartData } from "source/models/report/dashboardChartData";
import { DashboardChart } from "source/components/framework/DashboardChart";
import { getFilterStatePropsFromEventGeneralFilter, IEventGeneralFilter } from "./EventPageUtils";

export interface IEventPageDashboardChartProp {
    companyId: string;
    chartPanel: ISavedChartPanel;
    chartItems: IChartItem[];
    onShowChartPanelPropertiesDialog: (panelId: string) => void;
}

export interface IEventPageDashboardChartState extends IEventGeneralFilter {
    isLoading: boolean;
    chartData: IDashboardChartData;
    chartId: string;
    reportId: string;
    parameterValues: IReportParameterValue[]
}

export class EventPageDashboardChart extends React.Component<IEventPageDashboardChartProp, IEventPageDashboardChartState> {
    _isMounted: boolean;

    getStateChangeFromProps = (props: IEventPageDashboardChartProp): any => {
        const chartItem = props.chartPanel && props.chartItems
            ? props.chartItems.find(i => i.reportName === props.chartPanel.reportId)
            : null;
        const reportFilterProps = getFilterStatePropsFromEventGeneralFilter(props.chartPanel?.generalFilter);
        const result = {
            startDate: reportFilterProps.selectedStartDate ? reportFilterProps.selectedStartDate : null,
            endDate: reportFilterProps.selectedEndDate ? reportFilterProps.selectedEndDate : null,
            unitIds: reportFilterProps.selectedUnitIds ? reportFilterProps.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [],
            states: reportFilterProps.selectedStateIds ? reportFilterProps.selectedStateIds.map(i => i.toInteger(true)).filter(i => i >= 0) : [],
            urgencyClassIds: reportFilterProps.selectedUrgencyClassIds ? reportFilterProps.selectedUrgencyClassIds.filter(i => i !== Base.emptyGuid) : [],
            eventTypeIds: reportFilterProps.selectedEventTypeIds ? reportFilterProps.selectedEventTypeIds.filter(i => i !== Base.emptyGuid) : [],
            eventTypeBIds: reportFilterProps.selectedEventTypeBIds ? reportFilterProps.selectedEventTypeBIds.filter(i => i !== Base.emptyGuid) : [],
            eventTypeCIds: reportFilterProps.selectedEventTypeCIds ? reportFilterProps.selectedEventTypeCIds.filter(i => i !== Base.emptyGuid) : [],
            partnerCompanyIds: reportFilterProps.selectedPartnerCompanyIds ? reportFilterProps.selectedPartnerCompanyIds.filter(i => i !== Base.emptyGuid) : [],
            createUserCodes: reportFilterProps.selectedCreateUserCodes ? reportFilterProps.selectedCreateUserCodes.filter(i => !!i) : [],
            handlerUserCodes: reportFilterProps.selectedHandlerUserCodes ? reportFilterProps.selectedHandlerUserCodes.filter(i => !!i) : [],
            observers: reportFilterProps.selectedObservers ? reportFilterProps.selectedObservers.filter(i => i !== Base.emptyGuid) : [],
            dynamicTimeFilterId: reportFilterProps.selectedDynamicTimeFilterId ? parseInt(reportFilterProps.selectedDynamicTimeFilterId, 10) : 0,
            reportId: props.chartPanel?.reportId ?? "",
            chartId: props.chartPanel?.chartId ?? "",
            parameterValues: props.chartPanel && chartItem ? props.chartPanel.getReportParameterValues(chartItem) : []
        };
        return result;
    };

    constructor(props: IEventPageDashboardChartProp) {
        super(props);
        this.state = {
            ...this.getStateChangeFromProps(props),
            chart: "",
            isLoading: true
        };
    }

    setLoading = (value: boolean) => {
        if (!this._isMounted) return;
        this.setState({ isLoading: value });
    };

    createChart = async () => {
        const props = this.props;
        const state = this.state;
        if (!this._isMounted || !props.chartPanel || !props.chartItems || state.parameterValues.length < 1) return;
        this.setLoading(true);
        // const chart = await AppUtils.callService(() => eventService.getChart(props.chartPanel.id, props.companyId, props.chartPanel.reportId, props.chartPanel.chartId,
        //     state.startDate, state.endDate, state.dynamicTimeFilterId, state.unitIds, state.states, state.urgencyClassIds, state.eventTypeIds, state.eventTypeBIds, state.eventTypeCIds,
        //     state.partnerCompanyIds, state.createUserCodes, state.handlerUserCodes, state.observers, state.parameterValues), false, true, () => this.setLoading(false));
        const chartData = await AppUtils.callService(() => eventService.getChart(props.chartPanel.id, props.companyId, props.chartPanel.reportId, props.chartPanel.chartId,
            state.startDate, state.endDate, state.dynamicTimeFilterId, state.unitIds, state.states, state.urgencyClassIds, state.eventTypeIds, state.eventTypeBIds, state.eventTypeCIds,
            state.partnerCompanyIds, state.createUserCodes, state.handlerUserCodes, state.observers, state.parameterValues), false, true, () => this.setLoading(false));
        if (!this._isMounted) return;
        this.setState({
            chartData
            //chart
        });
    };

    componentDidUpdate(prevProps: IEventPageDashboardChartProp) {
        const state = this.state;
        const prevCompanyId = prevProps.companyId;
        const newState = this.getStateChangeFromProps(this.props);
        const prevChartId = state.chartId;
        const chartId = newState.chartId;
        const prevReportId = state.reportId;
        const reportId = newState.reportId;
        const prevStartDate = state.startDate ?? -99;
        const startDate = newState.startDate ?? -99;
        const prevEndDate = state.endDate ?? -99;
        const endDate = newState.endDate ?? -99;
        const prevStates = state.states ? state.states : [];
        const states = newState.states ? newState.states : [];
        const prevDynamicTimeFilterId = state.dynamicTimeFilterId ?? 0;
        const dynamicTimeFilterId = newState.dynamicTimeFilterId ?? 0;
        const prevParameterValues = state.parameterValues ?? [];
        const parameterValues = newState.parameterValues ?? [];
        if (prevCompanyId === this.props.companyId &&
            prevReportId === reportId && prevChartId === chartId &&
            prevStartDate.toString(10) === startDate.toString(10) &&
            prevEndDate.toString(10) === endDate.toString(10) &&
            prevDynamicTimeFilterId.toString(10) === dynamicTimeFilterId.toString(10) &&
            Base.equalStrArrays(state.unitIds, newState.unitIds) &&
            Base.equalStrArrays(prevStates.map(i => i.toString(10)), states.map(i => i.toString(10))) &&
            Base.equalStrArrays(state.urgencyClassIds, newState.urgencyClassIds) &&
            Base.equalStrArrays(state.eventTypeIds, newState.eventTypeIds) &&
            Base.equalStrArrays(state.eventTypeBIds, newState.eventTypeBIds) &&
            Base.equalStrArrays(state.eventTypeCIds, newState.eventTypeCIds) &&
            Base.equalStrArrays(state.partnerCompanyIds, newState.partnerCompanyIds) &&
            Base.equalStrArrays(state.createUserCodes, newState.createUserCodes) &&
            Base.equalStrArrays(state.handlerUserCodes, newState.handlerUserCodes) &&
            Base.equalStrArrays(state.observers, newState.observers) &&
            JSON.stringify(prevParameterValues) === JSON.stringify(parameterValues)) return;
        this.setState({
            ...newState
        }, this.createChart);
    }

    componentDidMount(): void {
        this._isMounted = true;
        this.createChart();
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }
    
    render() {
        const props = this.props;
        const state = this.state;
        const chartPanel = props.chartPanel;
        if (!chartPanel) return null;
        return (
            <DashboardChart
                panelId={chartPanel.id}
                title={chartPanel.getTitle()}
                chartData={state.chartData}
                isLoading={state.isLoading}
                onShowProperties={props.onShowChartPanelPropertiesDialog}
            />
        );
    }
}